import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Image from '../../../../../Image';
import Columns from '../Columns';
import Total from './Total';
import { transformPrompt } from '../../../../../../utils';
import { ROW_LABEL_CLASSNAME } from '../../constants';
import useToggle from '../../hooks/useToggle';

export default function Row({
  row,
  rowOrder,
  openEndedStyle,
  openEndedInputSize,
  openEndedSignPlacement,
  openEndedSign,
  min,
  max,
  total,
  decimals,
  showDivider,
  getText,
  openEndedConstantSumType,
}) {
  const { onClickRowLabel, onBlurToggle } = useToggle();
  const [inputValues, setInputValues] = useState({});

  const onChange = (key, value) => {
    setInputValues({
      ...inputValues,
      [key]: value,
    });
  };

  const isEmptyLabel = !row.label || row.label === '<div></div>';

  return (
    <Fragment>
      <div
        id={row.id}
        className="answer--matrix-open-ended"
        onBlur={onBlurToggle}
        data-testid="matrix-row"
      >
        {!isEmptyLabel && (
          <button
            type="button"
            className={ROW_LABEL_CLASSNAME}
            onClick={onClickRowLabel}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: transformPrompt(row.label) || '&nbsp;',
            }}
          />
        )}
        <div className="answer--matrix-open-ended-content-wrapper">
          <Image row={row} />
          <Columns
            rowId={row.id}
            rowRefId={row.refId}
            rowOrder={rowOrder}
            columns={row.columns}
            openEndedStyle={openEndedStyle}
            openEndedInputSize={openEndedInputSize}
            openEndedSignPlacement={openEndedSignPlacement}
            openEndedSign={openEndedSign}
            min={min}
            max={max}
            decimals={decimals}
            onChange={onChange}
          />
        </div>
        <div className="answer--matrix-open-ended-row-total">
          <Total
            getText={getText}
            total={total}
            inputValues={inputValues}
            decimals={decimals}
            openEndedSign={openEndedSign}
            openEndedConstantSumType={openEndedConstantSumType}
          />
        </div>
        {showDivider && <div className="divider margin-md"></div>}
      </div>
    </Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.object,
  rowOrder: PropTypes.string,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  openEndedSign: PropTypes.string,
  openEndedSignPlacement: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  decimals: PropTypes.number,
  total: PropTypes.number,
  showDivider: PropTypes.bool,
  getText: PropTypes.func,
  openEndedConstantSumType: PropTypes.string,
};
